import React from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import "./galleryTeaser.scss"
import { useScrollReveal } from "../../../utils/useScrollReveal"

const photos = Array.from({ length: 16 }, (_, i) => `/images/gallery/photo${i + 1}.jpg`)

const GalleryTeaser = () => {
  const { t } = useTranslation('home')
  const navigate = useNavigate()
  const { ref, visible } = useScrollReveal<HTMLElement>()

  const goToGallery = () => {
    navigate('/gallery')
    window.scrollTo(0, 0)
  }

  return (
    <section className={`gallery-teaser padding${visible ? ' visible' : ''}`} ref={ref}>
      <div className='container'>
        <div className='section-header'>
          <span className='section-label'>{t('Gallery', { ns: 'gallery' })}</span>
          <h2>{t('The castle in pictures')}</h2>
          <span className='gold-rule' />
        </div>
        <div className='gallery-teaser__grid'>
          {photos.map((src, index) => (
            <div className='gallery-teaser__item' key={index} onClick={goToGallery}>
              <img src={src} alt='Château Le Corvier' loading='lazy' />
              <div className='gallery-teaser__overlay'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.35-4.35" />
                </svg>
              </div>
            </div>
          ))}
        </div>
        <div className="button-container">
          <button onClick={goToGallery} className="show-rooms-button">
            {t('Show More')}
          </button>
        </div>
      </div>
    </section>
  )
}

export default GalleryTeaser
